<template>
    <settings-page
        v-slot="{ formProcessing, onSubmit }"
        :show="show"
        class="show-settings-subscribe-links"
    >
        <subscribe-links
            :show="show"
            :form-processing="formProcessing"
            @submit="onSubmit"
        />
    </settings-page>
</template>
<script>
import SettingsPage from './SettingsPage';
import SubscribeLinks from '@/components/Shows/Settings/SubscribeLinks';

export default {
    components: {
        SettingsPage,
        SubscribeLinks,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },
};
</script>
